import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import Logo from '../../imgs/logo.png';
import '../../styles/nav.css';
import i18n from '../../i18n';
import { withNamespaces } from 'react-i18next';

const Navbar = ({t}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.getElementById('mySidenav').style.width = '320px';
    } else {
      document.getElementById('mySidenav').style.width = '0';
    }
  });

  const openNav = () => {
    setIsOpen(true);
    if (document.getElementById('mySidenav')) {
      document.getElementById('mySidenav').style.width = '320px';
    }
    setMenu(inicialMenu);
    setActive(inicialActive);
  };

  const closeNav = () => {
    setIsOpen(false);
    if (document.getElementById('mySidenav')) {
      document.getElementById('mySidenav').style.width = '0';
    }
    setMenu(inicialMenu);
    setActive(inicialActive);
  };
  /* DROPDOWN*/

  const inicialMenu = {
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option6: false,
  };

  const inicialActive = {
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option6: false,
  };
  const [menu, setMenu] = useState(inicialMenu);

  const [active, setActive] = useState(inicialActive);

  const toogleMenu = (optionName) => {
    let menu_aux = {};
    let element_active = {};
    for (const key in menu) {
      menu_aux[key] = key === optionName ? !menu[key] : false;
    }
    for (const key in active) {
      element_active[key] = key === optionName ? !menu[key] : false;
    }
    setMenu(menu_aux);
    setActive(element_active);
  };


  const collapseOnClickItem = (optionName) => {
    setIsOpen(false);
    toogleMenu(optionName)
  };


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);


  }
  
  const lingua = i18n.language; 
  console.log(lingua);

  return (

    <nav className="navbar navbar-expand sticky-top">
      <div className="container navP">
        {/*side menu*/}
        <div id="mySidenav" className="sidenav">
          <p className="closebtn" onClick={closeNav}>
            &times;
          </p>

          {/*PRIMEIRO*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option1')}>
            <span className={active.option1 ? 'active' : null}>
              <span className="row">
                <NavHashLink
                  to="/estudarua#start"
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T1.Title')}
                  onClick={closeNav}
                >
                  {t('moduleSidemenu:T1.T')}
                </NavHashLink>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option1}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option1}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option1 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="/estudarua#1"
                title={t('moduleSidemenu:T1.Title1')}
                onClick={() => collapseOnClickItem("option1")}
              >
                {t('moduleSidemenu:T1.S1')}
              </NavHashLink>
              <NavHashLink
                to="/estudarua#2"
                title={t('moduleSidemenu:T1.Title2')}
                onClick={() => collapseOnClickItem("option1")}
              >
                {t('moduleSidemenu:T1.S2')}
              </NavHashLink>
              <NavHashLink
                to="/estudarua#3"
                title={t('moduleSidemenu:T1.Title3')}
                onClick={() => collapseOnClickItem("option1")}
              >
                {t('moduleSidemenu:T1.S3')}
              </NavHashLink>
            </div>
          )}

          {/*SEGUNDO*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option2')}>
            <span className={active.option2 ? 'active' : null}>
              <span className="row">
                <NavHashLink
                  to="/cidadeaveiro#start"
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T2.Title')}
                  onClick={closeNav}
                >
                  {t('moduleSidemenu:T2.T')}
                </NavHashLink>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option2}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option2}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option2 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="/cidadeaveiro#1"
                title={t('moduleSidemenu:T2.Title1')}
                onClick={() => collapseOnClickItem("option2")}
              >
                {t('moduleSidemenu:T2.S1')}
              </NavHashLink>
              <NavHashLink
                to="/cidadeaveiro#2"
                title={t('moduleSidemenu:T2.Title2')}
                onClick={() => collapseOnClickItem("option2")}
              >
                {t('moduleSidemenu:T2.S2')}
              </NavHashLink>
              <NavHashLink
                to="/cidadeaveiro#3"
                title={t('moduleSidemenu:T2.Title3')}
                onClick={() => collapseOnClickItem("option2")}
              >
                {t('moduleSidemenu:T2.S3')}
              </NavHashLink>
              <NavHashLink
                to="/cidadeaveiro#4"
                title={t('moduleSidemenu:T2.Title4')}
                onClick={() => collapseOnClickItem("option2")}
              >
                {t('moduleSidemenu:T2.S4')}
              </NavHashLink>
            </div>
          )}

          {/*TERCEIRO*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option3')}>
            <span className={active.option3 ? 'active' : null}>
              <span className="row">
                <NavHashLink
                  to="/prepararviagem#start"
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T3.Title')}
                  onClick={closeNav}
                >
                  {t('moduleSidemenu:T3.T')}
                </NavHashLink>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option3}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option3}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option3 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="/prepararviagem#1"
                title={t('moduleSidemenu:T3.Title1')}
                onClick={() => collapseOnClickItem("option3")}
              >
                {t('moduleSidemenu:T3.S1')}
              </NavHashLink>
              <NavHashLink
                to="/prepararviagem#2"
                title={t('moduleSidemenu:T3.Title2')}
                onClick={() => collapseOnClickItem("option3")}
              >
                {t('moduleSidemenu:T3.S2')}
              </NavHashLink>
              <NavHashLink
                to="/prepararviagem#3"
                title={t('moduleSidemenu:T3.Title3')}
                onClick={() => collapseOnClickItem("option3")}
              >
                {t('moduleSidemenu:T3.S3')}
              </NavHashLink>
              <NavHashLink
                to="/prepararviagem#4"
                title={t('moduleSidemenu:T3.Title4')}
                onClick={() => collapseOnClickItem("option3")}
              >
                {t('moduleSidemenu:T3.S4')}
              </NavHashLink>
              <NavHashLink
                to="/prepararviagem#5"
                title={t('moduleSidemenu:T3.Title5')}
                onClick={() => collapseOnClickItem("option3")}
              >
                {t('moduleSidemenu:T3.S5')}
              </NavHashLink>
            </div>
          )}

          {/*QUARTA*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option4')}>
            <span className={active.option4 ? 'active' : null}>
              <span className="row">
                <NavHashLink
                  to="/chegadaaveiro#start"
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T4.Title')}
                  onClick={closeNav}
                >
                  {t('moduleSidemenu:T4.T')}
                </NavHashLink>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option4}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option4}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option4 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="/chegadaaveiro#1"
                title={t('moduleSidemenu:T4.Title1')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S1')}
              </NavHashLink>
              <NavHashLink
                to="/chegadaaveiro#2"
                title={t('moduleSidemenu:T4.Title2')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S2')}
              </NavHashLink>
              <NavHashLink
                to="/chegadaaveiro#3"
                title={t('moduleSidemenu:T4.Title3')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S3')}
              </NavHashLink>
              <NavHashLink
                to="/chegadaaveiro#4"
                title={t('moduleSidemenu:T4.Title4')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S4')}
              </NavHashLink>
              <NavHashLink
                to="/chegadaaveiro#5"
                title={t('moduleSidemenu:T4.Title5')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S5')}
              </NavHashLink>
              <NavHashLink
                to="/chegadaaveiro#6"
                title={t('moduleSidemenu:T4.Title6')}
                onClick={() => collapseOnClickItem("option4")}
              >
                {t('moduleSidemenu:T4.S6')}
              </NavHashLink>
            </div>
          )}

          {/*QUINTA*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option5')}>
            <span className={active.option5 ? 'active' : null}>
              <span className="row">
                <NavHashLink
                  to="processointegracao#start"
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T5.Title')}
                  onClick={closeNav}
                >
                  {t('moduleSidemenu:T5.T')}
                </NavHashLink>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option5}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option5}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option5 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="processointegracao#1"
                title={t('moduleSidemenu:T5.Title1')}
                onClick={() => collapseOnClickItem("option5")}
              >
                {t('moduleSidemenu:T5.S1')}
              </NavHashLink>
              <NavHashLink
                to="processointegracao#2"
                title={t('moduleSidemenu:T5.Title2')}
                onClick={() => collapseOnClickItem("option5")}
              >
                {t('moduleSidemenu:T5.S2')}
              </NavHashLink>
              <NavHashLink
                to="processointegracao#3"
                title={t('moduleSidemenu:T5.Title3')}
                onClick={() => collapseOnClickItem("option5")}
              >
                {t('moduleSidemenu:T5.S3')}
              </NavHashLink>
              <NavHashLink
                to="processointegracao#4"
                title={t('moduleSidemenu:T5.Title4')}
                onClick={() => collapseOnClickItem("option5")}
              >
                {t('moduleSidemenu:T5.S4')}
              </NavHashLink>
            </div>
          )}
          <span className="row">
            <NavHashLink
              to="/vidaacademica#start"
              className="col-12"
              title={t('moduleSidemenu:T6.Title')}
              onClick={closeNav}
            >
              {t('moduleSidemenu:T6.T')}
            </NavHashLink>
          </span>

          <span className="row">
            <NavHashLink
              to="/todolist#start"
              className="col-12"
              title={t('moduleSidemenu:T7.Title')}
              onClick={closeNav}
            >
              {t('moduleSidemenu:T7.T')}
            </NavHashLink>
          </span>

          {/*SEXTA*/}
          <div className="dropdown-btn" onClick={() => toogleMenu('option6')}>
            <span className={active.option6 ? 'active' : null}>
              <span className="row">
                <div
                  className="linkSide col-8"
                  title={t('moduleSidemenu:T8.Title')}
                >
                  {t('moduleSidemenu:T8.T')}
                </div>
                <span className="MargemSeta col-2">
                  <i
                    hidden={menu.option6}
                    className="fas fa-chevron-down ms-3 "
                  ></i>
                  <i
                    hidden={!menu.option6}
                    className="fas fa-chevron-up ms-3"
                  ></i>
                </span>
              </span>
            </span>
          </div>
          {menu.option6 && (
            <div className="fontLighterMenu">
              <NavHashLink
                to="/contactosestruturas#start"
                title={t('moduleSidemenu:T8.Title1')}
                onClick={() => collapseOnClickItem("option6")}
              >
                {t('moduleSidemenu:T8.S1')}
              </NavHashLink>
              <NavHashLink
                to="/contactosemergencia#start"
                title={t('moduleSidemenu:T8.Title2')}
                onClick={() => collapseOnClickItem("option6")}
              >
                {t('moduleSidemenu:T8.S2')}
              </NavHashLink>
            </div>
          )}
          <span className="row">
            <NavHashLink
              to="/faqs#start"
              className="col-12"
              title={t('moduleSidemenu:T9.Title')}
              onClick={closeNav}
            >
              {t('moduleSidemenu:T9.T')}
            </NavHashLink>
          </span>
        </div>
        <div className="hamburguer col-4 text-start" onClick={openNav}>
          <i className="fas fa-bars fa-lg"></i>
        </div>

        {/*logo*/}
        <div className="col-4 text-center">         
          <NavHashLink
              to="/#start"
              className="navbar-brand p-0 m-0"
              title={t('moduleSidemenu:Navbar.GEI.Title')}
              >
              <img className="logoSize" src={Logo} alt={t('moduleSidemenu:Navbar.GEI.Alt')} />
          </NavHashLink>
        </div>

        {/*right content*/}
        <div className="d-flex icons col-4 ms-auto">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item ">
                {lingua == 'pt' ?
                  <Link onClick={() => changeLanguage('pt')} className="nav-link p-0 cont" title={t('moduleSidemenu:Navbar.Lng.Title1')}>
                    <span> PT </span>
                  </Link>
                  : 
                  <Link onClick={() => changeLanguage('pt')} className="nav-link p-0 " title={t('moduleSidemenu:Navbar.Lng.Title1')}>
                    <span> PT </span>
                  </Link>
                  }
                {/* <Link to="/construcao#start" className="nav-link p-0" title="Mudar para o idioma português"> */}
              </li>
              <span className="p-1"></span>

              <li className="nav-item">
                {/* <button className="nav-link p-0" onClick={() => changeLanguage('en')}>EN</button> */}
                {lingua == 'en' ?
                    <Link onClick={() => {changeLanguage('en')}} className="nav-link p-0 cont" title={t('moduleSidemenu:Navbar.Lng.Title2')}>
                      <span> EN </span>
                    </Link>
                : <Link onClick={() => {changeLanguage('en')}} className="nav-link p-0" title={t('moduleSidemenu:Navbar.Lng.Title2')}>
                <span> EN </span>
              </Link>}
              </li>
            </ul>
        </div>
      </div>
    </nav>
  );
};

export default withNamespaces() (Navbar);